import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { dentalBasePath } from "../../../../helper";

const ProjectsShortCut = () => {
  const navigate = useNavigate();
  return (
    <div className="project_short_cut_container">
      <div
        className="project_short_cut_body"
        onClick={() => navigate(`${dentalBasePath}/projects`)}
      >
        <p className="project_short_cut_heading">
          Manage Your Dental ID Projects
        </p>
        <div
          className="project_short_cut_button"
          onClick={() => navigate(`${dentalBasePath}/projects`)}
        >
          <span>View All Projects</span>
        </div>
      </div>
    </div>
  );
};

export default ProjectsShortCut;
